import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import "../../styles/customers/createCustomer.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { utcToLocal, utcToDDMMYYYY } from "../../utils/dateConvert";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

class EditAsset extends Component {

  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      customerId: "",
      customerName: "",
      customerString: "",
      name: "",
      friendlyName: "",
      tag1: "",
      tag2: "",
      description: "",
      profiles: [],
      profilesId: "",
      profileName: "",
      profileString: "",
      color: "",
      icon: "",
      notes: "",
      adminNotes: "",
      status: [],
      statusId: "",
      statusName: "",
      statusString: "",
      id: "",
      error: false,
      depots: [],
      depotName: "",
      depotId: "",
      dbCreated: "",
      dbUpdated: "",
      micTick: "",
      sosTick: "",
      tempaTick: "",
      tempbTick: "",
      harshTick: "",
      driverTick: "",
      dashTick: "",
      customerError: false,
      nameError: false,
      tag1Error: false,
      tag2Error: false,
      descriptionError: false,
      profileError: false,
      featureError: false,
      colorError: false,
      iconError: false,
      noteError: false,
      adminNoteError: false,
      statusError: false,
      installedDate: "",
      installedDateTick: false,
      uninstalledDate: "",
      uninstalledDateTick: false,
    };
    this.apiInstalled = "";
    this.apiUninstalled = "";
  }
  async componentDidMount() {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.post(
        `${apiHost}/api/Assets/SelectAsset/${this.props.match.params.id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setData(response.data);
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }


    if (localStorage.getItem('role') === "SystemAdmin") {
      this.getCustomers();
      this.getDepots();
    }
    this.getProfiles();
    this.getStatus();
  }

  setData = (data) => {
    const {
      name,
      friendlyName,
      tag1,
      tag2,
      notes,
      profile,
      profilesId,
      status,
      statusId,
      icon,
      description,
      customerName,
      customerId,
      colour,
      adminNotes,
      id,
      depot,
      depotId,
      dbCreated,
      dbUpdated,
      speakerandMic,
      sosDuress,
      tempA,
      tempB,
      harshEvents,
      driverID,
      dashCamera,
      installed,
      unInstalled,
    } = data;

    this.setState({
      name,
      friendlyName,
      tag1,
      tag2,
      description,
      color: colour,
      icon,
      notes,
      adminNotes,
      customerName,
      customerString: customerName,
      profileName: profile,
      profileString: profile,
      statusName: status,
      statusString: status,
      profilesId,
      statusId,
      customerId,
      id,
      depotName: depot,
      depotId,
      dbCreated,
      dbUpdated,
      micTick: speakerandMic,
      sosTick: sosDuress,
      tempaTick: tempA,
      tempbTick: tempB,
      harshTick: harshEvents,
      driverTick: driverID,
      dashTick: dashCamera,
      installedDate: new Date(installed),
      uninstalledDate: new Date(unInstalled),
    });

    this.apiInstalled = installed;
    this.apiUninstalled = unInstalled;
  };

  getCustomers = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllCustomers`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ customers: response.data });
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getDepots = async () => {
    try {
      const response = await axios.get(
        `${apiHost}/api/Depots/GetAllDepots?assetId=${this.props.match.params.id}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        console.log("the depots", response.data);
        this.setState({ depots: response.data });
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getProfiles = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(`${apiHost}/api/Assets/GetAllProfile`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        this.setState({ profiles: response.data });
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getStatus = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(`${apiHost}/api/Assets/GetAllStatus`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        this.setState({ status: response.data });
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleCancel = () => {
    this.props.history.push("/customers");
  };

  handleName = (evt) => {
    if (evt.target.value == "") {
      this.setState({ nameError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.setState({ name: evt.target.value });
  };

  handlefriendlyName = (evt) => {
    this.setState({ friendlyName: evt.target.value });
  };

  handleTag1 = (evt) => {
    this.setState({ tag1: evt.target.value });
  };

  handleTag2 = (evt) => {
    this.setState({ tag2: evt.target.value });
  };

  handleCustomer = (evt) => {
    this.state.customers.forEach((customer) => {
      if (customer.name == evt.target.value) {
        this.setState({
          customerId: customer.id,
          customerString: customer.name,
        });
      }
    });
  };

  handleDepot = (evt) => {
    if (evt.target.value == "default") {
      this.setState({ depotId: null, depotName: 'Select Depot' });
    }
    this.state.depots.forEach((depot) => {
      if (depot.name == evt.target.value) {
        this.setState({ depotId: depot.id, depotName: depot.name });
      }
    });
  };

  handleDescription = (evt) => {
    this.setState({ description: evt.target.value });
  };

  handleProfile = (evt) => {
    this.state.profiles.forEach((profile) => {
      if (profile.profileName == evt.target.value) {
        this.setState({
          profilesId: profile.id,
          profileString: profile.profileName,
          profileName: profile.profileName,
        });
      }
    });
  };

  handleColor = (evt) => {
    this.setState({ color: evt.target.value });
  };

  handleIcon = (evt) => {
    this.setState({ icon: evt.target.value });
  };

  handleNotes = (evt) => {
    this.setState({ notes: evt.target.value });
  };

  handleAdminNotes = (evt) => {
    this.setState({ adminNotes: evt.target.value });
  };

  handleStatus = (evt) => {
    if (evt.target.value == "") {
      this.setState({ statusError: true });
    } else {
      this.setState({ statusError: false });
    }
    this.state.status.forEach((stats) => {
      if (stats.name == evt.target.value) {
        this.setState({
          statusId: stats.id,
          statusString: stats.name,
          statusName: stats.name,
        });
      }
    });
  };

  handleCreate = async () => {
    this.validationCheck();
    console.log("createe", this.state)
    let {
      name,
      friendlyName,
      description,
      tag1,
      tag2,
      customerId,
      color,
      icon,
      notes,
      adminNotes,
      profilesId,
      statusId,
      depotId,
      profileName,
      statusName,
      installedDate,
      uninstalledDate,
    } = this.state;

    if (this.state.installedDate.toString().includes("Mon Jan 01 0001 00:00:00")) {
      installedDate = "0001-01-01T00:00:00";
    } else {
      installedDate.setMinutes(installedDate.getMinutes() - installedDate.getTimezoneOffset());
    }

    if (this.state.uninstalledDate.toString().includes("Mon Jan 01 0001 00:00:00")) {
      uninstalledDate = "0001-01-01T00:00:00";
    } else {
      uninstalledDate.setMinutes(uninstalledDate.getMinutes() - uninstalledDate.getTimezoneOffset());
    }

    if (name && customerId && profilesId && statusId) {
      this.props.setLoadingPageAction(true);
      try {
        const response = await axios.post(
          `${apiHost}/api/Assets/Update`,
          {
            Name: name,
            friendlyName: friendlyName,
            Description: description,
            CustomerId: customerId,
            Tag1: tag1,
            Tag2: tag2,
            ProfilesName: profileName,
            Features: 20,
            Colour: color,
            Icon: icon,
            Notes: notes,
            AdminNotes: adminNotes,
            StatusName: statusName,
            ExternalId: 111,
            id: this.state.id,
            DepotId: depotId,
            SpeakerandMic: this.state.micTick,
            SOSDuress: this.state.sosTick,
            TempA: this.state.tempaTick,
            TempB: this.state.tempbTick,
            HarshEvents: this.state.harshTick,
            DriverID: this.state.driverTick,
            DashCamera: this.state.dashTick,
            Installed: installedDate,
            UnInstalled: uninstalledDate,
            // Installed: installedDate
            //   .toString()
            //   .includes("Mon Jan 01 0001 00:00:00")
            //   ? installedDate
            //   : installedDate,
            // UnInstalled: uninstalledDate
            //   .toString()
            //   .includes("Mon Jan 01 0001 00:00:00")
            //   ? uninstalledDate
            //   : uninstalledDate,
            //DbCreated:new Date(dbCreated),
            //DbUpdated:new Date(dbUpdated)
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        if (response.status == "200") {
          //  this.props.history.push("/assets");
          this.props.history.goBack();
          this.props.setLoadingPageAction(false);
        }
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
        this.setState({ error_authorisation: true });
      }
    } else {
      this.setState({ error: true });
      setTimeout(() => {
        this.setState({ error: false });
      }, 3000);
    }
  };

  validationCheck = () => {
    if (!this.state.name) {
      this.setState({ nameError: true });
    }
    // if(!this.state.description){
    //   this.setState({descriptionError:true})
    // }
    // if(!this.state.tag1){
    //   this.setState({tag1Error:true})
    // }
    // if(!this.state.tag2){
    //   this.setState({tag2Error:true})
    // }
    if (!this.state.customerId) {
      this.setState({ customerError: true });
    }
    // if(!this.state.color){
    //   this.setState({colorError:true})
    // }
    // if(!this.state.icon){
    //   this.setState({iconError:true})
    // }
    // if(!this.state.notes){
    //   this.setState({noteError:true})
    // }
    // if(!this.state.adminNotes){
    //   this.setState({adminNoteError:true})
    // }
    if (!this.state.profilesId) {
      this.setState({ profileError: true });
    }
    if (!this.state.statusId) {
      this.setState({ statusError: true });
    }
  };

  handleBack = () => {
    // this.props.history.push("/assets");
    this.props.history.goBack();
  };

  handleMic = (e) => {
    this.setState({ micTick: !this.state.micTick });
  };

  handleSos = (e) => {
    this.setState({ sosTick: !this.state.sosTick });
  };

  handleTempA = (e) => {
    this.setState({ tempaTick: !this.state.tempaTick });
  };

  handleTempB = (e) => {
    this.setState({ tempbTick: !this.state.tempbTick });
  };

  handleHarsh = (e) => {
    this.setState({ harshTick: !this.state.harshTick });
  };

  handleDriver = (e) => {
    this.setState({ driverTick: !this.state.driverTick });
  };

  handleDash = (e) => {
    this.setState({ dashTick: !this.state.dashTick });
  };

  handleInstalledCalender = (date) => {
    console.log("dateis...", utcToDDMMYYYY(date));
    this.setState({ installedDate: date });
    this.setState({ installedDateTick: false });
  };

  handleOPenInstalledCalander = () => {
    this.setState({ installedDateTick: !this.state.installedDateTick });
  };

  handleUnInstalledCalender = (date) => {
    console.log("uninstalled date selectedd", date);
    this.setState({ uninstalledDate: date });
    this.setState({ uninstalledDateTick: false });
  };

  handleOPenUnInstalledCalander = () => {
    this.setState({ uninstalledDateTick: !this.state.uninstalledDateTick });
  };

  handleTrashInstalled = () => {
    if (this.state.installedDateTick <= 0) {
      this.setState({ installedDate: "Mon Jan 01 0001 00:00:00" });
    }
  };

  handleTodayInstalled = () => {
    if (this.state.installedDateTick <= 0) {
      this.setState({ installedDate: new Date() });
    }
  };

  handleTrashUninstalled = () => {
    if (this.state.uninstalledDateTick <= 0) {
      this.setState({ uninstalledDate: "Mon Jan 01 0001 00:00:00" });
    }
  };
  handleTodayUninstalled = () => {
    if (this.state.uninstalledDateTick <= 0) {
      this.setState({ uninstalledDate: new Date() });
    }
  };

  render() {
    const {
      name,
      friendlyName,
      description,
      tag1,
      tag2,
      color,
      icon,
      notes,
      adminNotes,
      profiles,
      status,
      customerName,
      profileString,
      statusString,
      depots,
      depotName,
      dbCreated,
      dbUpdated,
      customerError,
      nameError,
      profileError,
      statusError,
      installedDate,
      uninstalledDate,
    } = this.state;

    var selectDepot;
    if (depotName) {
      selectDepot = (
        <Form.Control as="select" onChange={this.handleDepot} value={depotName} disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}>
          {localStorage.getItem('role') === "SystemAdmin" ?
            <option value="default">Select Depot</option>: ''}
          {localStorage.getItem('role') === "SystemAdmin" ?
            depots.map((depot, index) => (
              <option key={index}>{depot.name}</option>
            )) : <option disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}>{depotName}</option>
          }


        </Form.Control>
      );
    } else {
      selectDepot = (
        <Form.Control as="select" onChange={this.handleDepot} >
          <option value="default">Select Depot</option>
          {depots.map((depot, index) => (
            <option key={index}>{depot.name}</option>
          ))}
        </Form.Control>
      );
    }
    console.log("instedsdf date is....", installedDate);
    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Edit Asset </title>
          </Helmet>
          <div className="formContainer">
            <h3>Edit Asset</h3>
            <span>{name}</span>
            <hr />
            <div className="formGroupSub">
              <Form>
                <Form.Group as={Row} controlId="formPlainTimeZone">
                  <Form.Label column sm="2">
                    Customer
                  </Form.Label>
                  <Col sm="4">
                    <p
                      className="detailsValue"
                      style={{ position: "relative", top: "8px" }}
                    >
                      {customerName}
                    </p>
                    <p
                      style={
                        customerError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Customer field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlainTimeZone" disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}>
                  <Form.Label column sm="2" >
                    Depot
                  </Form.Label>
                  <Col sm="4">{selectDepot}</Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName" disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}>
                  <Form.Label column sm="2">
                    Name
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      value={name}
                      onChange={this.handleName}
                      type="plaintext"
                      placeholder=""
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    />
                    <p
                      style={
                        nameError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Name field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Friendly Name
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      value={friendlyName}
                      onChange={this.handlefriendlyName}
                      type="plaintext"
                      placeholder=""
                    />
                    {/* <p
                      style={
                        nameError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Name field is required.
                    </p> */}
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Tag1
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      value={tag1}
                      onChange={this.handleTag1}
                      type="plaintext"
                      placeholder=""
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Tag2
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      value={tag2}
                      onChange={this.handleTag2}
                      type="plaintext"
                      placeholder=""
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Description
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      value={description}
                      as="textarea"
                      rows="3"
                      onChange={this.handleDescription}
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlainTimeZone">
                  <Form.Label column sm="2">
                    Profile
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      as="select"
                      onChange={this.handleProfile}
                      value={profileString}
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    >
                      <option value="default">Select Profile</option>
                      {profiles.map((profile, index) => (
                        <option key={index} value={profile.profileName}>{profile.profileName}</option>
                      ))}
                    </Form.Control>
                    <p
                      style={
                        profileError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Profile field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName" >
                  <Form.Label column sm="2">
                    Features
                  </Form.Label>
                  <Col sm="10">
                    <Form.Check
                      checked={this.state.micTick}
                      onChange={(e) => this.handleMic(e)}
                      inline
                      label="Speaker & Mic"
                      type="checkbox"
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    />
                    <Form.Check
                      checked={this.state.sosTick}
                      onChange={(e) => this.handleSos(e)}
                      inline
                      label="SOS (Duress) "
                      type="checkbox"
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    />
                    <Form.Check
                      checked={this.state.tempaTick}
                      onChange={(e) => this.handleTempA(e)}
                      inline
                      label="Temp A"
                      type="checkbox"
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    />
                    <Form.Check
                      checked={this.state.tempbTick}
                      onChange={(e) => this.handleTempB(e)}
                      inline
                      label="Temp B"
                      type="checkbox"
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    />
                    <Form.Check
                      checked={this.state.harshTick}
                      onChange={(e) => this.handleHarsh(e)}
                      inline
                      label="Harsh Events"
                      type="checkbox"
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    />
                    <Form.Check
                      checked={this.state.driverTick}
                      onChange={(e) => this.handleDriver(e)}
                      inline
                      label="Driver ID"
                      type="checkbox"
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    />
                    <Form.Check
                      checked={this.state.dashTick}
                      onChange={(e) => this.handleDash(e)}
                      inline
                      label="Dash Camera"
                      type="checkbox"
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    />
                    {/* <div>
                      Value:<span>0</span>
                    </div> */}
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Color
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      value={color}
                      onChange={this.handleColor}
                      type="plaintext"
                      placeholder=""
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Icon
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      value={icon}
                      onChange={this.handleIcon}
                      type="plaintext"
                      placeholder=""
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Notes
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      value={notes}
                      as="textarea"
                      rows="3"
                      onChange={this.handleNotes}

                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName" hidden={localStorage.getItem('role') === "SystemAdmin" ? false : true}>
                  <Form.Label column sm="2">
                    Admin Notes
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      value={adminNotes}
                      as="textarea"
                      rows="3"
                      onChange={this.handleAdminNotes}
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlainTimeZone">
                  <Form.Label column sm="2">
                    Status
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      as="select"
                      onChange={(e) => this.handleStatus(e)}
                      value={statusString}
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    >
                      {status.map((stats, index) => (
                        <option key={index}>{stats.name}</option>
                      ))}
                    </Form.Control>
                    <p
                      style={
                        statusError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Status field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Installed
                  </Form.Label>
                  <Col sm="5">
                    <Button
                      onClick={this.handleOPenInstalledCalander}
                      variant="light"
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    >
                      {installedDate
                        .toString()
                        .includes("Mon Jan 01 0001 00:00:00")
                        ? "Date Asset Was Installed"
                        : utcToDDMMYYYY(installedDate)}
                    </Button>
                    <Button
                      variant="light"
                      className="asset-calender"
                      onClick={this.handleTodayInstalled}
                      title="Go to today"
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    >
                      <span>
                        <i className="fa fa-asterisk" />
                      </span>
                    </Button>
                    <Button
                      variant="light"
                      className="asset-calender"
                      onClick={this.handleTrashInstalled}
                      title="Clear Selection"
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    >
                      <span>
                        <i className="fa fa-trash-o" />
                      </span>
                    </Button>
                    {this.state.installedDateTick > 0 && (
                      <div className="calenderDiv">
                        <Calendar
                          onChange={this.handleInstalledCalender}
                          value={
                            this.state.installedDate
                              .toString()
                              .includes("Mon Jan 01 0001 00:00:00")
                              ? new Date()
                              : this.state.installedDate
                          }
                        />
                      </div>
                    )}
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Uninstalled
                  </Form.Label>
                  <Col sm="9">
                    <Button
                      onClick={this.handleOPenUnInstalledCalander}
                      variant="light"
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    >
                      {uninstalledDate
                        .toString()
                        .includes("Mon Jan 01 0001 00:00:00")
                        ? "Date Asset Was Uninstalled"
                        : utcToDDMMYYYY(uninstalledDate)}
                    </Button>
                    <Button
                      variant="light"
                      className="asset-calender"
                      onClick={this.handleTodayUninstalled}
                      title="Go to today"
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    >
                      <span>
                        <i className="fa fa-asterisk" />
                      </span>
                    </Button>
                    <Button
                      variant="light"
                      className="asset-calender"
                      onClick={this.handleTrashUninstalled}
                      title="Clear Selection"
                      disabled={localStorage.getItem('role') === "SystemAdmin" ? false : true}
                    >
                      <span>
                        <i className="fa fa-trash-o" />
                      </span>
                    </Button>
                    {this.state.uninstalledDateTick > 0 && (
                      <div className="calenderDiv">
                        <Calendar
                          onChange={this.handleUnInstalledCalender}
                          value={
                            this.state.uninstalledDate
                              .toString()
                              .includes("Mon Jan 01 0001 00:00:00")
                              ? new Date()
                              : this.state.uninstalledDate
                          }
                        />
                      </div>
                    )}
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlainTimeZone">
                  <Form.Label column sm="2">
                    Created
                  </Form.Label>
                  <Col sm="4">
                    <p
                      className="detailsValue"
                      style={{ position: "relative", top: "8px" }}
                    >
                      {utcToLocal(dbCreated)}
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlainTimeZone">
                  <Form.Label column sm="2">
                    Updated
                  </Form.Label>
                  <Col sm="4">
                    <p
                      className="detailsValue"
                      style={{ position: "relative", top: "8px" }}
                    >
                      {utcToLocal(dbUpdated)}
                    </p>
                  </Col>
                </Form.Group>

                <Row>
                  <Col sm="2"></Col>
                  <Col sm="9">
                    <Button variant="light" onClick={this.handleBack}>
                      Back to List
                    </Button>
                    &nbsp; &nbsp;
                    <Button variant="primary" onClick={this.handleCreate}>
                      Save
                    </Button>
                  </Col>
                </Row>
                {this.state.error && (
                  <Row>
                    <Col sm="2"></Col>
                    <Col sm="9">
                      <p className="error-text">
                        Please fill all the Required fields
                      </p>
                    </Col>
                  </Row>
                )}

                {/* <Form.Group as={Row} controlId="formPlainAddress">
               <Form.Label  column sm="2">Address</Form.Label>
               <Col sm="4">
               <div>Position (<span>{lat}, {lng})</span></div>
               <div>{address}</div>
               </Col>
              </Form.Group>  */}
              </Form>
              <br />
              <br />
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});

const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditAsset);
